import { isEqual } from "lodash";
import { isValidDate } from "src/utils/time-utils";

import { FormField } from "./interfaces";

export const validateOnAddItem = (formFields: FormField[], item: any) => {
  if (formFields && item) {
    const formFieldsValues = formFields
      .filter(({ required }) => required !== false)
      .some(({ field, fieldType }) => {
        return item[field] === null || item[field] === "" || (fieldType === "datePicker" && !isValidDate(item[field]));
      });

    return formFieldsValues;
  }
};

export const validateOnEditItem = (formFields: FormField[], item: any, resetItem: any) => {
  if (formFields && item) {
    const formFieldRequiredValues = formFields
      .filter(({ required }) => required === undefined)
      .some(({ field }) => !isEqual(item[field], resetItem[field]));

    const formFieldChangedValues = formFields
      .filter(({ required }) => required !== undefined)
      .some(({ field }) => !isEqual(item[field], resetItem[field]));

    const requiredFieldsAreEmpty = formFields
      .filter(({ required }) => required !== false)
      .some(
        ({ field, fieldType }) =>
          item[field] === null || item[field] === "" || (fieldType === "datePicker" && !isValidDate(item[field]))
      );

    if (requiredFieldsAreEmpty) return requiredFieldsAreEmpty;

    return !formFieldRequiredValues && !formFieldChangedValues;
  }
};

export const changeYearFormat = (date: string) => {
  const arr = date.split("-");
  const newDay = arr[2].split("T")[0];
  arr.pop();
  arr.push(newDay);

  return arr.join("-");
};
